import { render, staticRenderFns } from "./BigCrunchButton.vue?vue&type=template&id=21d2c158&scoped=true"
import script from "./BigCrunchButton.vue?vue&type=script&lang=js"
export * from "./BigCrunchButton.vue?vue&type=script&lang=js"
import style0 from "./BigCrunchButton.vue?vue&type=style&index=0&id=21d2c158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d2c158",
  null
  
)

export default component.exports